export default function middlewarePipeline(context: Record<string, unknown>, middleware: any[], index: number): any {
  const nextMiddleware = middleware[index];

  if (!nextMiddleware) {
    return context.next;
  }
  return () => {
    nextMiddleware({
      ...context,
      next: middlewarePipeline(context, middleware, index + 1),
    });
  };
}
